import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = ["href"];
const _hoisted_3 = {
  key: 1
};
import validateService from '@/utils/validate';
const __default__ = {
  name: 'AppLink'
};
function setup(__props) {
  return (_ctx, _cache) => {
    const _component_router_link = _resolveComponent("router-link");
    return _unref(validateService).isExternal(__props.to) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("a", {
      href: __props.to,
      target: "_blank",
      rel: "noopener"
    }, [_renderSlot(_ctx.$slots, "default")], 8, _hoisted_2)])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_router_link, {
      to: __props.to
    }, {
      default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
      _: 3
    }, 8, ["to"])]));
  };
}
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    to: {
      type: String,
      required: true,
      default: ''
    }
  },
  setup
});